module.exports = __webpack_public_path__ + "img/nearby-d.8ebb4f7f.png";